<template>
  <div class="party-directory-grid">
    <button
      v-for="child in children"
      :key="child.path"
      type="button"
      class="party-directory-card"
      @click="front.goPath(child.path)"
    >
      <strong>{{ child.label }}</strong>
      <span v-if="child.subtitle">{{ child.subtitle }}</span>
    </button>
    <p v-if="!children.length" class="muted-copy">暂无已发布内容，请在管理后台维护</p>
  </div>
</template>

<script>
export default {
  name: 'PartyDirectoryGrid',
  inject: ['front'],
  props: {
    section: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    children() {
      return (this.section && this.section.children) || []
    }
  }
}
</script>
